import styled from "styled-components";

export const QuestionWrapper = styled.section`
  margin: 0 auto;
  padding: 16px;
  width: 80%;
  max-width: 1200px;
`;

export const AnswersWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;

export const QuestionText = styled.div`
  p {
    display: flex;
    flex-direction: column-reverse;
    justify-content: center;
    align-items: center;
    font-size: 24px;
    font-weight: 600;

    img {
      margin-bottom: 32px;
      width: 100%;
      height: auto;
    }
  }
`;
